import customerReport from './customerReport'
export default customerReport
